import { Panel, Flex, Typography, Button } from '@maxhub/max-ui';
import { useAuthStore } from '../store/auth.store.ts';

export function PendingApprovalPage() {
  const { reset } = useAuthStore();

  return (
    <Panel centeredX centeredY style={{ minHeight: '100vh', padding: '1rem' }}>
      <Flex
        direction="column"
        align="center"
        gap={12}
        style={{
          maxWidth: 400,
          width: '100%',
          background: 'var(--color-bg-secondary, #ffffff)',
          borderRadius: 12,
          padding: '2rem 1.5rem',
          textAlign: 'center',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ fontSize: '3rem' }}>⏳</div>

        <Typography.Headline variant="medium-strong" style={{ display: 'block' }}>
          Ожидает подтверждения
        </Typography.Headline>

        <Typography.Label style={{ display: 'block' }}>
          Ваша заявка на регистрацию отправлена администратору ТСН «Рокада».
        </Typography.Label>

        <Typography.Label style={{ display: 'block' }}>
          После подтверждения вы получите уведомление и сможете войти в приложение.
        </Typography.Label>

        <Typography.Label style={{ display: 'block', opacity: 0.6 }}>
          Обычно это занимает не более одного рабочего дня.
        </Typography.Label>

        <Button mode="link" onClick={reset}>
          Выйти
        </Button>
      </Flex>
    </Panel>
  );
}
